import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.UserAndGroupsEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.UserAndGroupsList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.UserAndGroupsCreate })));

export default { edit, list, create };
